import React, { useState } from 'react';
import { ui } from './toolTheme';
const API_BASE = process.env.REACT_APP_API_BASE || '';

const UrlToolkitPage = ({ setPage }) => {
  const [url, setUrl] = useState('');
  const [shortUrl, setShortUrl] = useState('');
  const [base, setBase] = useState('https://example.com/landing');
  const [utmSource, setUtmSource] = useState('google');
  const [utmMedium, setUtmMedium] = useState('cpc');
  const [utmCampaign, setUtmCampaign] = useState('spring_sale');
  const [utmResult, setUtmResult] = useState('');
  const [err, setErr] = useState('');

  const shorten = async () => {
    setErr('');
    try {
      const res = await fetch(`${API_BASE}/api/url/shorten`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ url }) });
      const data = await res.json(); if (!res.ok) throw new Error(data.error || 'Failed');
      setShortUrl(data.short_url || '');
    } catch (e) { setErr(e.message || 'Failed'); }
  };

  const buildUtm = async () => {
    setErr('');
    try {
      const res = await fetch(`${API_BASE}/api/url/build-utm`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ base_url: base, utm_source: utmSource, utm_medium: utmMedium, utm_campaign: utmCampaign }) });
      const data = await res.json(); if (!res.ok) throw new Error(data.error || 'Failed');
      setUtmResult(data.url || '');
    } catch (e) { setErr(e.message || 'Failed'); }
  };

  return <main style={ui.page}><div style={{...ui.container, maxWidth:860}}>
    <button onClick={()=>setPage('/tools')} style={ui.backBtn}>← Back to Tools</button>
    <div style={ui.card}><h1 style={ui.sectionTitle}>URL Shortener + UTM Builder</h1></div>
    <div style={{...ui.card, marginTop:14}}>
      <h3 style={{color:'#cbd5e1'}}>Shorten URL</h3>
      <input value={url} onChange={(e)=>setUrl(e.target.value)} placeholder='https://...' style={ui.input} />
      <button onClick={shorten} style={{...ui.primaryBtn, marginTop:8}}>Shorten</button>
      {shortUrl && <div style={ui.success}>{shortUrl}</div>}
    </div>
    <div style={{...ui.card, marginTop:14}}>
      <h3 style={{color:'#cbd5e1'}}>UTM Builder</h3>
      <input value={base} onChange={(e)=>setBase(e.target.value)} placeholder='Base URL' style={{...ui.input, marginBottom:8}} />
      <input value={utmSource} onChange={(e)=>setUtmSource(e.target.value)} placeholder='Source' style={{...ui.input, marginBottom:8}} />
      <input value={utmMedium} onChange={(e)=>setUtmMedium(e.target.value)} placeholder='Medium' style={{...ui.input, marginBottom:8}} />
      <input value={utmCampaign} onChange={(e)=>setUtmCampaign(e.target.value)} placeholder='Campaign' style={ui.input} />
      <button onClick={buildUtm} style={{...ui.primaryBtn, marginTop:8}}>Build UTM URL</button>
      {utmResult && <div style={ui.success}>{utmResult}</div>}
      {err && <div style={ui.error}>{err}</div>}
    </div>
  </div></main>;
};

export default UrlToolkitPage;
